<ng-container *ngIf="evaluatedDisplayText$ | async as header; else skeletonLoader">
  <p-card [header]="header" class="entity-name-header">
    <p *ngIf="evaluatedDisplayDescription$ | async as txt" class="m-0">
      {{ txt }}
    </p>
  </p-card>
</ng-container>

<ng-template #skeletonLoader>
  <div class="p-skeleton skeleton-container"></div>
</ng-template>
